import CloseIcon from "@mui/icons-material/Close";
import InputAdornment from "@mui/material/InputAdornment";
import { FlexRow, IconButton, SingleSelect, TextField } from "designSystem/index";
import { useLocale } from "designSystem/locale";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { useBaseCompositionStore } from "./BaseCompositionStore";
import { CompositionPlacement } from "./CompositionPlacement";
import { SalesRegionException } from "./SalesRegionException";

interface BaseCompositionPlacementSingleItemInnerRowContentProps {
	/** Required property representing the current placement */
	currentPlacement: CompositionPlacement;

	/** Optional property representing the index with default value of 0 */
	index?: number;

	/** Optional property indicating if dragging is active with default value of false */
	isDragging?: boolean;

	/** Required property representing the sales region exception */
	salesRegionException: SalesRegionException;
} 

const BaseCompositionPlacementSingleItemInnerRowContent: FunctionComponent<BaseCompositionPlacementSingleItemInnerRowContentProps> = observer(
	function BaseCompositionMaterialSingleItem(props) {
		const { currentPlacement, index = 0, isDragging = false, salesRegionException } = props;
		const {
			getSelectActions,
		} = useBaseCompositionStore();
		const {
			getCurrentPlacementDropdownValue,
			hasMultiplePlacements,
			getPlacementItemsForDropdown,
			removePlacementComposition,
		} = salesRegionException;
		const {
			baseCompositionMaterials,
			materialBOMs,
			key,
			percentageIsInvalid,
			percentageFixed,
			placementPercentageBackground,
			setUrlFromItem,
			onClickPlacementGoToDialog,
		} = currentPlacement;
		const loc = useLocale();
		const showPercentage = (baseCompositionMaterials.length > 0 || materialBOMs.length > 0) && !isDragging;
		const placementOptions = getPlacementItemsForDropdown(index);

		return (
			<FlexRow 
				alignItems="center"
				data-csi-automation="CompositionPlacementAggregated"
				gap={2}
				width="100%"
			>
				<SingleSelect
					dataCsiAutomation="Select-Composition-Placement"
					disableClearable
					fullWidth
					onChange={setUrlFromItem}
					options={placementOptions.length === 1 ? [] : placementOptions}
					placeHolderRes="CompositionPlacementNoSelectedItems"
					selectActions={placementOptions.length > 1 ? getSelectActions(onClickPlacementGoToDialog) : null}
					value={getCurrentPlacementDropdownValue(currentPlacement)}
				/>
				{showPercentage && (
					<TextField
						InputProps={{ endAdornment:
						<InputAdornment position="end">
							{loc.resource("PercentageSign")}
						</InputAdornment>,
						style: { background: placementPercentageBackground },
						}}
						disabled
						error={percentageIsInvalid}
						placeholderRes="FormatDoublePercentage"
						sx={{ width: 100, minWidth: 100 }}
						type="text"
						value={percentageFixed}
					/>
				)}
				<IconButton
					disabled={!hasMultiplePlacements}
					onClick={() => removePlacementComposition(key)}
					size="small"
				>
					<CloseIcon />
				</IconButton>
			</FlexRow>
		);
	},
);

export default BaseCompositionPlacementSingleItemInnerRowContent;